import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { RopaComponent } from './features/ropa/ropa.component';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'ropa',
    component: RopaComponent,
  },
  {
    path: 'ropa/:id/:version',
    component: RopaComponent,
  },
  {
    path: 'ropa/:id',
    component: RopaComponent,
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
